import React, { useState } from "react";
import { BlogsService, ImageUploadUtil } from "../../../APIs";

import { useNavigate } from "react-router-dom";
import StepOne from "./StepForm/StepOne";

import { Steps, Button } from "antd";
import StepThree from "./StepForm/StepThree";
import { useNotification } from "../../Toast/Notification";
import { BlogState } from "../../../@types/productInfo";
import imageUploadUtilInstance from "../../../APIs/util";

const { Step } = Steps;

const AddBlogs: React.FC = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [title, setTitle] = useState<string>("");
  const [metaTitle, setMetaTitle] = useState<string>("");
  const [image, setImage] = useState<string>("");
  const [bloglink, setBlogLink] = useState<string>("");
  const [metaDescription, setMetaDescription] = useState<string>("");
  const [selectedFileImage, setSelectedFileImage] = useState<File | null>(null);
  const [editorContent, setEditorContent] = useState<string>("");
  const navigate = useNavigate();
  const { notify } = useNotification();
  const [isLoading, setIsLoading] = useState(false);

  const handleFileChangeImage = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      setSelectedFileImage(files[0]);
    }
  };

  const handleEditorChange = (content: string) => {
    setEditorContent(content);
  };


  const handleImageUpload = async (
    blobInfo: any,
    success: (url: string) => void,
    failure: (error: string) => void
  ) => {
    let file = blobInfo.blob ? blobInfo.blob() : null;
  
    if (!file && blobInfo.url) {
      success(blobInfo.url);
      return;
    }
  
    if (file) {
      try {
        const { data,  } = await imageUploadUtilInstance.uploadImage(file);
  
        if (typeof data === "string") {
          success(data);
        } else {
          failure("Image upload failed, no URL returned");
        }
      } catch (err) {
        failure("Image upload failed");
      }
    } else {
      failure("No valid image file detected");
    }
  };
  

  const handleFormSubmit = async (e: any) => {
    e.preventDefault();
    let imageUrl = "";
    setIsLoading(true);

    if (selectedFileImage) {
      const uploadedImage = await ImageUploadUtil.uploadImage(
        selectedFileImage
      );

      if (uploadedImage.data) {
        setImage(uploadedImage.data);
        imageUrl = uploadedImage.data;
      }
    }

    const blogData: BlogState = {
      title: title.toLowerCase(),
      meta_title: metaTitle,
      meta_description: metaDescription,
      blogText: editorContent,
      image: imageUrl,
      link: "",
      bloglink: bloglink,
    };

    try {
      const { data, error } = await BlogsService.createBlog(blogData);

      if (data) {

        notify("Blog has been successfully created!", "success");

        setTimeout(() => {
          navigate("/dashboard/blogs");
        }, 3000);
      } else {
        console.error("Error creating blog:", error);
        notify(
          "An error occured while creating blog, please try again!",
          "error"
        );
      }
    } catch (error) {
      console.error("Error creating blog:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const steps = [
    {
      title: "Information",
      content: (
        <StepOne
          title={title}
          setTitle={setTitle}
          metaTitle={metaTitle}
          setMetaTitle={setMetaTitle}
          metaDescription={metaDescription}
          setMetaDescription={setMetaDescription}
          selectedFileImage={selectedFileImage}
          setSelectedFileImage={setSelectedFileImage}
          handleFileChangeImage={handleFileChangeImage}
          bloglink={bloglink}
          setBlogLink={setBlogLink}
          image={image}
        />
      ),
    },
    {
      title: "Contenu",
      content: (
        <StepThree
          editorContent={editorContent}
          handleEditorChange={handleEditorChange}
          handleFormSubmit={handleFormSubmit}
          isLoading={isLoading}
          handleImageUpload={ handleImageUpload}
        />
      ),
    },
  ];

  const next = () => setCurrentStep(currentStep + 1);
  const prev = () => setCurrentStep(currentStep - 1);

  return (
    <div className="bg-white p-4 rounded-md w-5/4 mx-auto">
      <h2
        className=" pl-4  box-border text-[rgb(0,34,56)]
             block text-[20px] text-left h-[38px] font-semibold
            leading-[38.4px] mb-1">
        Write Blog
      </h2>
      <div className="p-8">
        <Steps current={currentStep}>
          {steps.map((item, index) => (
            <Step key={index} title={item.title} />
          ))}
        </Steps>
      </div>
      <div className="mt-">{steps[currentStep].content}</div>

      <div className="flex justify-between mt-4">
        {currentStep > 0 && (
          <Button onClick={prev} className="btn-secondary">
            Previous
          </Button>
        )}
        {currentStep < steps.length - 1 && (
          <div className="pl-4">
            <Button onClick={next} className="btn-secondary">
              Next
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AddBlogs;
